// From https://github.com/lovasoa/react-contenteditable/issues/35

const stripHTML = (htmlString) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = htmlString;
  return tmp.textContent;
};

export default stripHTML;
